import { render, staticRenderFns } from "./BulkSendMessages.vue?vue&type=template&id=456e6b69&scoped=true"
import script from "./BulkSendMessages.vue?vue&type=script&lang=js"
export * from "./BulkSendMessages.vue?vue&type=script&lang=js"
import style0 from "./BulkSendMessages.vue?vue&type=style&index=0&id=456e6b69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456e6b69",
  null
  
)

export default component.exports